// extracted by mini-css-extract-plugin
export default {"main":"PetBreeder_main__WNG-f","formDiv":"PetBreeder_formDiv__gz8Uy","form":"PetBreeder_form__U07Bs","input":"PetBreeder_input__hUvWC","select":"PetBreeder_select__7oyVv"};